import _ from 'lodash'
import { css } from 'styled-components'

import { ButtonRole, ButtonEmphasis, ButtonShape, ButtonSize, ButtonMinMaxSizes } from '../types'
import { getButtonDimensions, getButtonMinMaxSizes } from './buttonDimensions'
import { getButtonColors } from './buttonColors'
import { Loader } from '../../../../Loader'

const getButtonStylesUnmemoized = (
  shape: ButtonShape,
  emphasis: ButtonEmphasis,
  size: ButtonSize,
  role: ButtonRole,
  minMaxSizes: ButtonMinMaxSizes,
  disabled: boolean,
  disableFocusOnClick: boolean
) => {
  return [
    getButtonDimensions(shape, size),
    getButtonMinMaxSizes(minMaxSizes),
    getButtonColors(role, emphasis, disabled, disableFocusOnClick),
    css`
      overflow: hidden;
      position: relative;

      display: inline-flex;
      align-items: center;
      justify-content: center;

      & ${Loader} {
        width: 14px;
        height: 14px;
        position: absolute;
      }
    `
  ]
}

const serializeParams = (...params: Parameters<typeof getButtonStylesUnmemoized>): string => {
  return params.reduce((output, param) => output + param, '')
}

// This really, really, really needs to be memoized, so the generated classes have a stable
// reference and don't get re-generated every time
export const getButtonStyles = _.memoize(getButtonStylesUnmemoized, serializeParams)
